export default __webpack_public_path__ + "static/media/scabbard.94bc698e.svg";